// extracted by mini-css-extract-plugin
module.exports = {"questLayout":"style__questLayout__kXjOZ"};